/**
 * Which checkout /kassa renders.
 *
 * The licensed flag comes from Magento (Cart.requires_licensed_checkout), never from the storefront's
 * own SKU decorations: Magento's guards use the same rule, so the page and the guards cannot disagree.
 * Demo mode is checked first and changes nothing — testing either real flow means DEMO_CHECKOUT=false.
 */
export type CheckoutRoute = 'form' | 'licensed-form' | 'svea' | 'login';

export function chooseCheckout(input: {
  isDemo: boolean;
  sveaEnabled: boolean;
  requiresLicensedCheckout: boolean;
  loggedIn: boolean;
}): CheckoutRoute {
  if (input.isDemo) return 'form';
  if (input.requiresLicensedCheckout) return input.loggedIn ? 'licensed-form' : 'login';
  return input.sveaEnabled ? 'svea' : 'form';
}

/**
 * Where a guest with a licensed cart is sent. `reason` is allowlisted in lib/auth-reason.ts; `return`
 * goes through safeInternalPath in the login form.
 */
/**
 * Whether the checkout shows the licence-details step. Only the licensed form has it, and only while
 * the shop collects licence details (licensed_checkout/general/collect_declaration, off until Jeeves
 * confirms it can receive them). Without it the licensed form is otherwise unchanged.
 */
export function collectsLicenceDetails(
  route: CheckoutRoute,
  state: { collectsDeclaration: boolean } | null,
): boolean {
  return route === 'licensed-form' && Boolean(state?.collectsDeclaration);
}

export const LICENSED_CHECKOUT_LOGIN_PATH = '/konto/logga-in?return=%2Fkassa&reason=licensed-checkout';
